export const API_URL = 'https://adm.totalvia.com.br/api/totem/';
export const BASE_API_URL = 'https://adm.totalvia.com.br/api/';
// export const API_URL = 'https://homolog.totalvia.com.br/api/totem/';
// export const BASE_API_URL = 'https://homolog.totalvia.com.br/api/';
